<template>
    <div class="service-page">
        <div class="container" v-if="$route.name === 'services'">
            <h1 class="title is-1">Our Services</h1>
            <div class="services">
                <router-link :to="{name:'trees'}" tag="div" class="service">
                    <div class="service-bg trees"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Tree Relocation</div>
                            <div class="service-expand">
                                <div class="subtitle">Why a Tree Spade</div>
                                <div class="subtitle">Site Considerations</div>
                                <div class="subtitle">The Process</div>
                                <div class="subtitle">Post-Relocation Care</div>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:'erosion'}" tag="div" class="service">
                    <div class="service-bg hydro"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Erosion Control</div>
                            <div class="service-expand">
                                <div class="subtitle">Hydroseeding</div>
                                <div class="subtitle">Drillseeding</div>
                                <div class="subtitle">Silt Fencing</div>
                                <div class="subtitle">Blankets/Logs</div>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:'rows'}" tag="div" class="service">
                    <div class="service-bg rows"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Row Maintenance</div>
                            <div class="service-expand">
                                <div class="subtitle">Litter Removal</div>
                                <div class="subtitle">Roadside Mowing</div>
                                <div class="subtitle">Roadside Edging & Sweeping</div>
                                <div class="subtitle">Herbicide Application</div>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:'landscape'}" tag="div" class="service">
                    <div class="service-bg landscape"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Landscaping</div>
                            <div class="service-expand">
                                <div class="subtitle">Excavation</div>
                                <div class="subtitle">Planting</div>
                                <div class="subtitle">Irrigation</div>
                                <div class="subtitle">Hardscapes</div>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:'irrigation'}" tag="div" class="service">
                    <div class="service-bg irrigation"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Irrigation</div>
                            <div class="service-expand">
                                <div class="subtitle">Drip Systems</div>
                                <div class="subtitle">Popup Systems</div>
                                <div class="subtitle">Directional Spray</div>
                                <div class="subtitle">WiFi Controllers</div>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:'hydroaxe'}" tag="div" class="service">
                    <div class="service-bg hydroaxe"></div>
                    <div class="service-text">
                        <div>
                            <div class="title">Hydro-Axing</div>
                            <div class="service-expand">
                                <div class="subtitle">Erosion Prevention</div>
                                <div class="subtitle">Soil Stabilization</div>
                                <div class="subtitle">Moisture Retention</div>
                                <div class="subtitle">Wildlife Protection</div>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="hero is-large" v-if="$route.name !== 'services'">
            <div :class="{'hero-body hero-image': true, [$route.name]: true}"></div>
        </div>
        <div class="service-container" v-if="$route.name !== 'services'">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Services',
    };
</script>



// WEBPACK FOOTER //
// Services.vue?a9103380